import { Billing } from '@or-sdk/billing';

import { useAuth } from '@/stores';

import config from '../config';

export default new Billing({
  token: () => `USER ${useAuth().reactiveToken}`,
  serviceUrl: config.BILLING_API_URL,
});
